import type { TopBarItem } from '../../components/shell/topBarItems.ts';
import { ReloadButton } from './ReloadButton.tsx';

const item: TopBarItem = { id: 'reload', order: 100, Component: ReloadButton };
export default item;
